import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find.js";
import "regenerator-runtime/runtime.js";
import { useWalletStore } from '@/stores/useWalletStore';
var TWEET_URL = 'https://twitter.com/intent/tweet?text=';
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var MyAssets = function MyAssets() {
  return import('@/components/organisms/MyAssets');
};
import Nl2br from 'vue-nl2br';
import humps from 'humps';
var Award = function Award() {
  return import('@/components/atoms/Award');
};
var ToggleButton = function ToggleButton() {
  return import('@/components/atoms/ToggleButton');
};
var ArtEditButton = function ArtEditButton() {
  return import('@/components/atoms/ArtEditButton');
};
var LandBasicBox = function LandBasicBox() {
  return import('@/components/organisms/LandBasicBox');
};
var PhoneVerifyModal = function PhoneVerifyModal() {
  return import('@/components/molecules/PhoneVerifyModal');
};
import NgWords from '~/assets/data/ngwords.json';
var CountDown = function CountDown() {
  return import('@/components/molecules/CountDown');
};

// const PrimeIcon = () => import('@/components/atoms/PrimeIcon')
// const UserName = () => import('@/components/molecules/UserName')
// const ArtModal = () => import('@/components/organisms/ArtModal')
// const ShareModal = () => import('@/components/organisms/ShareModal')

export default {
  components: {
    PageTitle: PageTitle,
    Modal: Modal,
    MyAssets: MyAssets,
    Nl2br: Nl2br,
    Award: Award,
    ArtEditButton: ArtEditButton,
    LandBasicBox: LandBasicBox,
    PhoneVerifyModal: PhoneVerifyModal,
    CountDown: CountDown,
    ToggleButton: ToggleButton
    // ArtModal,
    // ShareModal,
    // UserName,
    // PrimeIcon,
  },
  data: function data() {
    return {
      isLangDropdownShown: false,
      isRenameModalShown: false,
      isEditCommentModalShown: false,
      isChangeIconModal: false,
      newUserName: '',
      newComment: '',
      trophies: [],
      heroAssets: [],
      sphereAssets: [],
      artAssets: [],
      awards: [],
      isUploading: false,
      cropperOpened: false,
      backPrev: false,
      landAssets: [],
      landInfo: {},
      guildInfo: {},
      ngwords: NgWords,
      isLandTab: true,
      isDropNotification: true,
      isShowTab1: true,
      isShowTab2: false,
      isShowTm: true,
      isShowEvent: false,
      isShowOther: false,
      showVerifyPhoneModal: false,
      id: 0
    };
  },
  validate: function validate(_ref) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var params;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _ref.params;
            return _context.abrupt("return", params.id != null);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    isPhoneValid: function isPhoneValid() {
      return usePhoneNumberStore().isPhoneValid;
    },
    me: function me() {
      return useUserStore().me;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getExtension: function getExtension() {
      return useExtensionStore().getExtension;
    },
    getLandSector: function getLandSector() {
      return useLandStore().getLandSector;
    },
    getLandInfo: function getLandInfo() {
      return useLandStore().getLandInfo;
    },
    primeLastTime: function primeLastTime() {
      var lastTime = this.$dayjs.duration(this.$dayjs(this.primeUntil * 1000).diff(this.$dayjs())).asSeconds();
      var dayInSec = 86400;
      return lastTime < dayInSec ? lastTime < 0 ? 0 : lastTime : 0;
    },
    primeUntil: function primeUntil() {
      return usePrimeStore().getPrimeUntil;
    },
    isPrime: function isPrime() {
      return usePrimeStore().isPrime;
    },
    primeLastDays: function primeLastDays() {
      return usePrimeStore().getPrimeLastDays;
    },
    user: function user() {
      return this.getUser(this.id);
    },
    isMe: function isMe() {
      if (!this.me) {
        return false;
      }
      return this.me.uid === this.id;
    },
    isTorus: function isTorus() {
      return useWalletStore().providerType === 'torus';
    },
    currentUrl: function currentUrl() {
      if (process.server) return;
      var path = this.localePath({
        name: 'users-id',
        params: {
          id: this.id
        }
      });
      return "".concat(this.$env.siteUrl.slice(0, -1)).concat(path);
    },
    totalAssets: function totalAssets() {
      var assetCount = 0;
      if (this.heroAssets != null) assetCount += this.heroAssets.length;
      if (this.sphereAssets != null) assetCount += this.sphereAssets.length;
      if (this.artAssets != null) assetCount += this.artAssets.length;
      if (this.landAssets != null) assetCount += this.landAssets.length;
      return assetCount;
    },
    currentAwards: function currentAwards() {
      var awards = this.$util.clone(this.awards) || [];
      if (this.isShowTm) {
        awards = awards.filter(function (x) {
          return x.tid >= 10000 && x.tid <= 99999;
        });
      } else if (this.isShowEvent) {
        awards = awards.filter(function (x) {
          return x.tid >= 100001 && x.tid <= 999999;
        });
      } else {
        awards = awards.filter(function (x) {
          return x.tid >= 1000001 && x.tid <= 9999999;
        });
      }
      return awards.sort(function (p, c) {
        if (p.at > c.at) return -1;
        if (p.at < c.at) return 1;
        return 0;
      });
    },
    getComment: function getComment() {
      return this.user.comment + '\n';
    },
    getBackUrl: function getBackUrl() {
      if (this.$route.query.missionId) {
        return this.localePath({
          path: "/quests/cooperation",
          query: {
            missionId: this.$route.query.missionId,
            page: this.$route.query.page,
            category: this.$route.query.category,
            cooperationType: this.$route.query.cooperationType
          }
        });
      } else {
        this.backPrev = true;
        return '';
      }
    },
    userProfilePic: function userProfilePic() {
      if (this.user.ipfs) {
        return "".concat(this.$env.cdnUrl, "/user_arts/").concat(this.user.ipfs);
      }
      return '';
    },
    isGuildJoined: function isGuildJoined() {
      return this.user.guildId > 0;
    },
    getLandIconUrl: function getLandIconUrl() {
      return "".concat(this.$env.staticUrl, "/land/landicon/land_icon_").concat(this.user.landType, ".png");
    },
    landName: function landName() {
      if (this.landInfo.name) {
        return this.landInfo.name[this.$i18n.locale];
      }
      return '';
    },
    landCitizensCount: function landCitizensCount() {
      if (this.landInfo.citizensList) {
        return this.landInfo.citizensList.length;
      }
      return 0;
    },
    guildName: function guildName() {
      if (this.guildInfo.alias) return this.guildInfo.alias;
      return '';
    },
    guildMemberCounts: function guildMemberCounts() {
      if (this.guildInfo.membersMap) return this.guildInfo.membersMap.length;
      return 0;
    },
    guildIcon: function guildIcon() {
      if (this.guildInfo.ipfs.includes('.png')) return "".concat(this.$env.cdnUrl, "/static/land/guildicon/").concat(this.guildInfo.ipfs);else return "".concat(this.$env.cdnUrl, "/user_arts/").concat(this.guildInfo.ipfs);
    },
    maxMemberCount: function maxMemberCount() {
      var maxMember = this.guildInfo.maxMember;
      return maxMember.base + maxMember.levelAdd + maxMember.volumeAdd;
    },
    landEmblemTypesList: function landEmblemTypesList() {
      return this.landInfo.emblemTypesList;
    },
    guildEmblemTypesList: function guildEmblemTypesList() {
      return this.guildInfo.emblemTypesList;
    },
    userEmblemTypesList: function userEmblemTypesList() {
      return this.user.emblemTypesList;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this.init();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    fetchHeroes: function fetchHeroes(ids) {
      return useHeroStore().fetchHeroes(ids);
    },
    fetchExtensions: function fetchExtensions(arg) {
      return useExtensionStore().fetchExtensions(arg);
    },
    fetchMyOwnExtensions: function fetchMyOwnExtensions() {
      return useExtensionStore().fetchMyOwnExtensions();
    },
    fetchLandInfo: function fetchLandInfo(arg) {
      return useLandStore().fetchLandInfo(arg);
    },
    fetchLandSectors: function fetchLandSectors(ids) {
      return useLandStore().fetchLandSectors(ids);
    },
    tweetMe: function tweetMe() {
      var tweetText = this.$t('users.twitterText');
      var hashTags = this.$t('users.hashtags');
      var tweetUrl = TWEET_URL + tweetText + '&url=' + this.currentUrl + hashTags;
      open(tweetUrl);
    },
    logout: function logout() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return useAuthStore().signOut();
            case 2:
              window.location.href = _this2.localePath('index');
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    setLang: function setLang(locale) {
      this.$router.push(this.switchLocalePath(locale.code));
      this.$i18n.setLocaleCookie(locale.code);
      this.closeLangDropdown();
    },
    onDropNotifyChange: function onDropNotifyChange(value) {
      this.$localStorage.set('ddnsetting', value ? 1 : 0);
    },
    closeLangDropdown: function closeLangDropdown() {
      this.isLangDropdownShown = false;
    },
    openChangeIconModal: function openChangeIconModal() {
      this.isChangeIconModal = true;
    },
    openRenameModal: function openRenameModal() {
      this.newUserName = this.user.name;
      this.isRenameModalShown = true;
    },
    closeRenameModal: function closeRenameModal() {
      this.newUserName = '';
      this.isRenameModalShown = false;
    },
    openEditCommentModal: function openEditCommentModal() {
      this.newComment = this.user.comment;
      this.isEditCommentModalShown = true;
    },
    closeEditCommentModal: function closeEditCommentModal() {
      this.newComment = '';
      this.isEditCommentModalShown = false;
    },
    onCopied: function onCopied(e) {
      this.$toast.success("Copied: ".concat(e.text));
    },
    onError: function onError() {
      this.$toast.error('Error');
    },
    rename: function rename() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_this3.newUserName === null || _this3.newUserName == '')) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              if (!_this3.containsNgWords(_this3.newUserName)) {
                _context4.next = 5;
                break;
              }
              _this3.$toast.error(_this3.$t('bulletinboard.ngwordAlert'));
              return _context4.abrupt("return");
            case 5:
              _context4.prev = 5;
              _context4.next = 8;
              return useUserStore().renameUser(_this3.newUserName);
            case 8:
              _this3.isRenameModalShown = false;
              // this.$toast.success('Player name changed.')
              _context4.next = 15;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](5);
              console.log(_context4.t0);
              _this3.$toast.error(_context4.t0.message || 'Error.');
            case 15:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[5, 11]]);
      }))();
    },
    editComment: function editComment() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this4.containsNgWords(_this4.newComment)) {
                _context5.next = 3;
                break;
              }
              _this4.$toast.error(_this4.$t('bulletinboard.ngwordAlert'));
              return _context5.abrupt("return");
            case 3:
              _context5.prev = 3;
              _context5.next = 6;
              return useUserStore().updateComment(_this4.newComment);
            case 6:
              _this4.isEditCommentModalShown = false;
              // this.$toast.success('Player name changed.')
              _context5.next = 13;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](3);
              console.log(_context5.t0);
              _this4.$toast.error(_context5.t0.message || 'Error.');
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[3, 9]]);
      }))();
    },
    init: function init() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var flag;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this5.id = Number(_this5.$route.params.id);
              if (_this5.$localStorage.get('ddnsetting') != null) {
                flag = Number(_this5.$localStorage.get('ddnsetting'));
                _this5.isDropNotification = flag == 1;
              } else {
                // default true
                _this5.$localStorage.set('ddnsetting', 1);
              }
              _context6.next = 4;
              return _this5.fetchPublicData();
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    openPhoneVerify: function openPhoneVerify() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this6.$adService.SendToGTM('phone_verification', null);
              data = {
                lang: _this6.$i18n.locale,
                url: "".concat(_this6.$env.siteUrl).concat(_this6.$i18n.locale, "/users/").concat(_this6.me.uid)
              }; // this.$mchplusAuth.OpenPhoneVerifyWindowFrom(data)
              _this6.showVerifyPhoneModal = true;
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    fetchPublicData: function fetchPublicData() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var heroIds, sphereIds, arts, landSectorIds, landSectors, i, titles, awards, titleIds, titleMasterList;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(_this7.isMe == false)) {
                _context8.next = 9;
                break;
              }
              _context8.prev = 1;
              _context8.next = 4;
              return useUserStore().fetchUser(_this7.id);
            case 4:
              _context8.next = 9;
              break;
            case 6:
              _context8.prev = 6;
              _context8.t0 = _context8["catch"](1);
              return _context8.abrupt("return", _this7.$nuxt.error({
                statusCode: 404,
                message: _this7.$t('common.errorMessage')
              }));
            case 9:
              _context8.next = 11;
              return _this7.$heroesService.getIds(_this7.user.uid);
            case 11:
              heroIds = _context8.sent;
              if (!(heroIds != null)) {
                _context8.next = 16;
                break;
              }
              _context8.next = 15;
              return _this7.fetchHeroes(heroIds);
            case 15:
              _this7.heroAssets = heroIds.map(function (id) {
                return _this7.getHero(id);
              });
            case 16:
              _context8.next = 18;
              return _this7.$extensionsService.getIds(_this7.user.uid);
            case 18:
              sphereIds = _context8.sent;
              if (!(sphereIds != null)) {
                _context8.next = 23;
                break;
              }
              _context8.next = 22;
              return _this7.fetchExtensions(sphereIds);
            case 22:
              _this7.sphereAssets = sphereIds.map(function (id) {
                return _this7.getExtension(id);
              });
            case 23:
              _context8.next = 25;
              return _this7.$heroesService.getArtsByUser(_this7.id);
            case 25:
              arts = _context8.sent;
              if (arts != null) {
                _this7.artAssets = arts;
              }
              _context8.next = 29;
              return _this7.$landService.getLandSectorIds(_this7.id);
            case 29:
              landSectorIds = _context8.sent;
              if (!(landSectorIds != null)) {
                _context8.next = 37;
                break;
              }
              _context8.next = 33;
              return _this7.fetchLandSectors(landSectorIds);
            case 33:
              landSectors = landSectorIds.map(function (id) {
                return _this7.getLandSector(id);
              });
              _this7.landAssets = _this7.$util.clone(landSectors);
              i = 0;
              landSectors.forEach(function (ls) {
                var masterData = useLandMaster().getSectorMaster(ls.landSectorType);
                _this7.landAssets[i].rarity = masterData.rarity;
                _this7.landAssets[i].landType = masterData.landType;
                i++;
              });
            case 37:
              _context8.next = 39;
              return _this7.$usersService.getTitles(_this7.user.uid);
            case 39:
              titles = _context8.sent;
              awards = titles.userTitlesList || [];
              titleIds = [];
              awards.forEach(function (x) {
                titleIds.push(x.tid);
              });
              _context8.next = 45;
              return _this7.$usersService.getTitleMasters(titleIds);
            case 45:
              titleMasterList = _context8.sent;
              awards.forEach(function (x) {
                var master = titleMasterList.find(function (m) {
                  return m.titleId == x.tid;
                });
                if (master) x.filename = master.filename;
              });
              _this7.awards = awards;
              if (!(_this7.user.landType != 0)) {
                _context8.next = 56;
                break;
              }
              _context8.next = 51;
              return _this7.fetchLandInfo({
                landType: _this7.user.landType,
                force: true
              });
            case 51:
              _this7.landInfo = _this7.getLandInfo(_this7.user.landType);
              if (!(_this7.user.guildId > 0)) {
                _context8.next = 56;
                break;
              }
              _context8.next = 55;
              return _this7.$landGuildService.GetGuildInfo(_this7.user.guildId);
            case 55:
              _this7.guildInfo = _context8.sent;
            case 56:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[1, 6]]);
      }))();
    },
    submit: function submit(_ref2) {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var data, formData, res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              data = _ref2.data;
              _this8.isUploading = true;
              formData = new FormData();
              formData.append('upload', data);
              _context9.prev = 4;
              _context9.next = 7;
              return _this8.$fetchPost("".concat(_this8.$env.apiUrl, "api/pixelator/user_art_upload"), formData);
            case 7:
              res = _context9.sent;
              _this8.pixelatedData = humps.camelizeKeys(res);
              _context9.next = 11;
              return useUserStore().updateProfile(_this8.pixelatedData.ipfs);
            case 11:
              _context9.next = 16;
              break;
            case 13:
              _context9.prev = 13;
              _context9.t0 = _context9["catch"](4);
              if (_context9.t0.response.status === 400 && _context9.t0.response.data.includes('ipfs already used')) {
                _this8.$toast.error('This image is already used.');
              } else {
                _this8.$toast.error('Error.');
              }
            case 16:
              _this8.isUploading = false;
              _this8.isChangeIconModal = false;
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[4, 13]]);
      }))();
    },
    emblemName: function emblemName(id) {
      var name = useLandCupMaster().getEmblemName(id);
      return name ? name[this.$i18n.locale] : '';
    },
    onClickTab1: function onClickTab1() {
      this.isShowTab1 = true;
      this.isShowTab2 = false;
    },
    onClickTab2: function onClickTab2() {
      this.isShowTab1 = false;
      this.isShowTab2 = true;
    },
    onClickShowTm: function onClickShowTm() {
      if (!this.isShowTm) {
        this.isShowTm = true;
        this.isShowEvent = false;
        this.isShowOther = false;
      }
    },
    onClickShowEvent: function onClickShowEvent() {
      if (!this.isShowEvent) {
        this.isShowTm = false;
        this.isShowEvent = true;
        this.isShowOther = false;
      }
    },
    onClickShowOther: function onClickShowOther() {
      if (!this.isShowOther) {
        this.isShowTm = false;
        this.isShowEvent = false;
        this.isShowOther = true;
      }
    },
    fetchDidVerifyPhone: function fetchDidVerifyPhone() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return usePhoneNumberStore().fetchValidatePhoneNumber();
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    containsNgWords: function containsNgWords(msg) {
      var isNgWord = false;
      if (msg) {
        for (var i = 0; i < this.ngwords.length; i++) {
          if (msg.includes(this.ngwords[i])) {
            isNgWord = true;
            break;
          }
        }
      }
      return isNgWord;
    } // async fetchArtLikes(art) {
    //   art.likes = await this.$heroesService.getLikes(art.ipfs)
    //   return art
    // }
  }
};